import React from 'react';
import { IProps } from './type';

const PendingIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox={viewBox ? viewBox : '0 0 20 20'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10 5.33301L10 2.99967" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 17L10 15.4444" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.4453 10L17.0009 10" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 10L5.33333 10" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.3984 5.59961L14.9484 5.04964" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.05078 14.9502L6.15073 13.8503" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.8496 13.8496L14.9496 14.9496" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.05078 5.0498L6.7007 6.69972" stroke={strokeColor ? strokeColor : "#4CAF50"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
};

export default PendingIcon;
